import type {
  NormalisedRequest,
  NormalisedRequestVolunteer,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests.types'
import type { NormalisedTaskType } from '@onhandtech/onhand-fe-shared/lib/api/v4/task-types/task-types.types'
import type { NormalisedVolunteerGroup } from '@onhandtech/onhand-fe-shared/lib/api/v4/volunteer-group/volunteer-group.types'

export const isNormalisedVolunteerGroup = (
  result: NormalisedRequestVolunteer | NormalisedVolunteerGroup,
): result is NormalisedVolunteerGroup => 'defaultGroup' in result

export const isNormalisedRequest = (
  result: NormalisedRequest | NormalisedTaskType,
): result is NormalisedRequest => 'name' in result && 'summary' in result && 'description' in result
